const html = window.html;
const routes = window.routes;

const Backbone = window.Backbone;

import QueryString from 'querystring';
import SubjectParameters from '../../../../../business-objects/SubjectParameters';

import FormatModel from '../models/FormatModel';

const FormatCollection = Backbone.Collection.extend({
    model: FormatModel,

    url() {
        return window.url(routes.rest.subjects.getCountByMediaType);
    },

    // Converts subject mediatype responses into their localized display value keys for use with html()
    labelMap: {
        all: 'all',
        ebook: 'ebooks',
        audiobook: 'audiobooks',
        magazine: 'magazines',
        video: 'videos',
    },

    // Transforms a moidifed SubjectCollection model into a flat model for use with the FormatNavigationView
    parse(response) {
        return _.map(response, (subjectCollection) => {
            let params = new SubjectParameters(
                subjectCollection.subjectParameters
            );

            // LHTNG-1320 See all link sort by 'Newly Added'
            params.sortBy = 'newlyadded';

            delete params.showOnlyAvailable;

            // LHTNG-4281 Use mediaTypes for url instead of mediaType
            if (params.mediaType !== 'all') {
                params.mediaTypes = params.mediaType;
                delete params.mediaType;
            }

            return {
                mediaType: subjectCollection.subjectParameters.mediaType,
                count: subjectCollection.uniqueTitles,
                label: html(
                    this.labelMap[
                        subjectCollection.subjectParameters.mediaType.toLowerCase()
                    ]
                ),
                href: `${window.url(routes.search)}?${QueryString.stringify(
                    params.serialize()
                )}`,
                selected: false,
            };
        });
    },

    selectMediaTypeByFormat(formatModel) {
        let currentFormatModel = this.findWhere({ selected: true });
        if (currentFormatModel) {
            currentFormatModel.set({ selected: false });
        }

        formatModel.set({ selected: true });
    },

    /**
     * Returns a collection of format models that have 1 or more titles and handles single format display logic
     */
    activeFormats() {
        let response = this.filter(
            (formatModel) => formatModel.get('count') > 0
        );

        let allFormat = this.findWhere({ mediaType: 'all' });

        // LHTNG-1316 - If the only two options are "All" and the only format that is active on the site
        if (response.length === 2 && _(response).contains(allFormat)) {
            // Remove the "All" option
            response = _(response).without(allFormat);
        }

        return response;
    },
});

export default FormatCollection;
